(function ($) {

    $(document).ready(function () {

        if ($.cookie("cookie-popup") != 'false') {
            $.cookie("cookie-popup", 'true', {expires: 365, path: '/'});
        } else {
            $(".cookie-popup").hide();
        }

        $(".cookie-popup .accept-btn").on("click", function () {
            allowCookie();
        });

        $(window).on('scroll', function () {
            if ($(window).scrollTop() >= 200) {
                allowCookie();
            }
        });

        $(window).on('beforeunload', function () {
            //allowCookie();
        });


        function allowCookie() {
            $.cookie("cookie-popup", 'false', {expires: 365, path: '/'});
            $(".cookie-popup").fadeOut('slow');
        }


    });

})(jQuery);


// WEBPACK FOOTER //
// ./src/js/custom/cookies.es6